/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';

import { SafePureComponent } from '../../../utils/SafePureComponent';
import Spacer from '../../ui/Spacer';
import * as styles from './index.styles';
import Video from './Video';
import Modal from '../../ui/Modal';
import { colorsPalette } from '../../../styles/colors';
import { Container, MediaQueries } from '../../../styles/Grid';
import { Breakpoints } from '../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';
import videoplay from './videoplay.png';
import { Picture } from '../../ui/Picture';

//import { Container, Column, Row, MediaQueries } from '../../../styles/Grid';

const defaultData = {};

const mainImageSizes = {};

export class FullWidthVideo extends SafePureComponent {
  constructor(props) {
    super(props);
    this.fields = defaultsDeep(props.rendering.fields, defaultData);
  }

  state = {
    showVideo: false,
  };

  toggleVideo = () => {
    this.setState({ showVideo: !this.state.showVideo });
  };

  safeRender() {
    const { showVideo } = this.state;

    const VIDEO_ID = get(this.fields, 'YouTubeVideoId.value', '');
    const VideoPlaceholderImage = get(this.fields, 'VideoPlaceholderImage', '');

    if (!VIDEO_ID) {
      return <div>No video id </div>;
      return false;
    }
    return (
      <Spacer customCss={styles.fullvideosec}>
        <div onClick={this.toggleVideo} aria-hidden="true">
          <React.Fragment>
            <Container className={styles.customContainer}>
              <div className="video_sec">
                {VideoPlaceholderImage && (
                  <Picture
                    image={VideoPlaceholderImage}
                    imageSizes={mainImageSizes}
                    imageClassName="video-thumb"
                    instantLoad
                  />
                )}
                {/* <img src={videobg} className="video-thumb" alt="video-thumb" /> */}
                <div className="video_txt">Our World has changed</div>

                <div className="play_icon">
                  <img src={videoplay} alt="video-thumb" />
                  <div className="play_btn">PLAY</div>
                </div>
              </div>
            </Container>
          </React.Fragment>

          <Modal
            // overlayProp={styles.modalCss}
            hideDefaultCloseButton
            contentBackground={colorsPalette.white}
            isOpen={showVideo}
            onRequestClose={this.toggleVideo}
          >
            <Video videoId={VIDEO_ID} toggleVideo={this.toggleVideo} />
          </Modal>
        </div>
      </Spacer>
    );
  }
}

FullWidthVideo.displayName = 'FullWidthVideo';

export default FullWidthVideo;
